import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { playWinner, playClick } from "../lib/sound";
import { MuteToggle } from "./MuteToggle";

export const WinnerScreen = ({ winnerName, color, onPlayAgain, onNewTeams }) => {
  useEffect(() => {
    playWinner();
  }, []);

  const handlePlayAgain = () => { playClick(); onPlayAgain(); };
  const handleNewTeams = () => { playClick(); onNewTeams(); };

  return (
  <div
    className="min-h-screen relative overflow-hidden flex items-center justify-center px-4"
    data-testid="winner-screen"
    style={{
      backgroundImage:
        "url('https://images.unsplash.com/photo-1698285439446-2ad560e31a17?crop=entropy&cs=srgb&fm=jpg&q=85')",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <div className="absolute inset-0 bg-[#111111]/75" />

    {/* Floating mute toggle */}
    <div className="fixed top-4 right-4 z-50">
      <MuteToggle />
    </div>

    <div className="relative z-10 max-w-3xl w-full text-center">
      <motion.div
        initial={{ scale: 0, rotate: -10 }}
        animate={{ scale: 1, rotate: -3 }}
        transition={{ type: "spring", stiffness: 80, damping: 12 }}
      >
        <span className="inline-block bg-[#FFD700] border-4 border-[#111111] px-4 py-1 font-mono-debate font-bold uppercase tracking-[0.3em] text-sm shadow-brutal-md">
          ★ Champion ★
        </span>
      </motion.div>

      <motion.h1
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, type: "spring", stiffness: 80 }}
        className="font-anton uppercase text-7xl md:text-[10rem] leading-[0.9] my-6 text-white"
        style={{ textShadow: "6px 6px 0px #111111" }}
      >
        WINNER!
      </motion.h1>

      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.4, type: "spring" }}
        className="border-4 border-[#111111] shadow-brutal-lg p-8 mb-10"
        style={{ backgroundColor: color }}
        data-testid="winner-banner"
      >
        <h2
          className="font-anton uppercase text-5xl md:text-7xl text-white break-words"
          data-testid="winner-name"
          style={{ textShadow: "4px 4px 0px #111111" }}
        >
          {winnerName}
        </h2>
        <p className="font-mono-debate font-bold uppercase tracking-[0.2em] text-white/90 mt-2 text-sm">
          Master Debaters Champions
        </p>
      </motion.div>

      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="flex flex-col md:flex-row gap-4 justify-center"
      >
        <button
          onClick={handlePlayAgain}
          data-testid="play-again-btn"
          className="btn-brutal-press bg-[#FF2A54] text-white border-4 border-[#111111] shadow-brutal-md font-anton uppercase text-3xl px-8 py-4"
        >
          Rematch
        </button>
        <button
          onClick={handleNewTeams}
          data-testid="new-teams-btn"
          className="btn-brutal-press bg-white text-[#111111] border-4 border-[#111111] shadow-brutal-md font-anton uppercase text-3xl px-8 py-4"
        >
          New Teams
        </button>
      </motion.div>
    </div>
  </div>
  );
};
